import './Navbar.css';
import BBIcon from "../../Assets/BB-Icon.svg";
import React, { useState } from "react";
import { Tabs, Tab, Container, Box, Toolbar, AppBar, Drawer, Typography, IconButton } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const location = useLocation();
  const tabValue = location.pathname === "/" || location.pathname === "/meet" || location.pathname === "/menu" ? location.pathname : false;

  const [drawerOpen, setDrawerOpen] = useState(false);
  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <AppBar
      position="sticky"
      component="nav"
    >
      <Toolbar>
        <Box sx={{ p: 1 }}>
          <img
            src={BBIcon}
            style={{ width: "48px", height: "48px", objectFit: "contain" }}
            alt="logo"
          />
        </Box>

        <Container
          sx={{
            display: { xs: 'none', sm: 'none', md: 'flex' },
            justifyContent: "center"
          }}
        >
          <Tabs
            value={tabValue}
            sx={{
              "& .MuiTab-root": { mx: 5 },
              "& .Mui-selected": {
                fontWeight: 700,
              },
              "& .MuiButtonBase-root.MuiTab-root.Mui-selected": {
                color: "secondary.main",
              },
            }}
          >
            <Tab label="Home" component={Link} to="/" value="/" />
            <Tab label="Meet the Chefs" component={Link} to="/meet" value="/meet" />
            <Tab label="Special Menu" component={Link} to="/menu" value="/menu" />
          </Tabs>
        </Container>

        <IconButton
          sx={{
            display: { md: 'none' },
            ml: 'auto',
          }}
          color="inherit"
          onClick={handleDrawerToggle}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerToggle}
      >
        <Box
          sx={{
            width: 250,
            padding: 2,
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>Navigation</Typography>
          <Tabs
            value={tabValue}
            orientation="vertical"
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Tab label="Home" component={Link} to="/" value="/" />
            <Tab label="Meet the Chefs" component={Link} to="/meet" value="/meet" />
            <Tab label="Special Menu" component={Link} to="/menu" value="/menu" />
          </Tabs>
        </Box>
      </Drawer>
    </AppBar>
  );
}

export default Navbar;
